import { cn } from '@repo/utils/cn';
import { type ReactNode } from 'react';

type HeaderRightSideProps = {
  children: ReactNode;
  className?: string;
};

export const HeaderRightSide = ({ children, className }: HeaderRightSideProps) => (
  <div className={cn('flex', 'items-center', 'space-x-1', className)}>{children}</div>
);
